import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';

const json = {
  1: { // Exercise num
    unit: 'Unit 4',
    id: 'SB3-U4-P32-E1',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [{ url: 'img/FriendsPlus/Page32/E1/1.jpg' }],
      [{ url: 'img/FriendsPlus/Page32/E1/2.jpg' }],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 4',
    id: 'SB3-U4-P31-E2',
    audio: 'img/FriendsPlus/Page32/Audio/audio-e2-p32.mp3',
    video: '',
    component: UI,
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page32/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page32/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page32/Audio/tieude-e2-p32.mp3' },
        { url: 'img/FriendsPlus/Page32/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page32/E2/4.jpg' },
      ],
    ],
  },
  3: { // Exercise num
    unit: 'Unit 4',
    id: 'SB3-U4-P32-E3',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page32/E3/Key/answerKey.png',
    titleQuestion: [{ num: '3', title: 'Read again. Circle the false word and write the correct word.', color: "#1F4199" }],
    question: {
      Write: {
        checkUppercase: true,
        inputStyle: { width: 200, marginLeft: 20, color: '#00a8ec' },
        answers: ['12', 'speak', 'read', 'Thursday'],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {},
        selectWordStyle: { border: 'solid 2px', borderColor: '#00a8ec', borderRadius: '50%', },
        limitSelect: 1,
        listWords: [
          'We have 18 computers', //1
          'The students can listen and eat', //2
          'The computers help the students to run and write', //3
          'The children come every Tuesday and Wednesday', //4
        ],
        answers: ['0-4', '1-10', '2-12', '3-12'],
        initialValue: [],
      },
      Layout: `
        <img src="img/FriendsPlus/Page32/E3/1.jpg" style="width: 100%">
        <div style='display: flex; flex-direction: row;position: relative;'>
          <div style='flex: 3'>
            <div><b>1</b>&nbsp;We have a <span style="border: 2px solid rgb(0, 168, 236);padding: 3px;border-radius: 50%;">small</span> computer room.</div>
            <div><b>2</b> <input id='0' type='Circle' />.</div>
            <div><b>3</b> <input id='1' type='Circle' />.</div>
            <div><b>4</b> <input id='2' type='Circle' />.</div>
            <div><b>5</b> <input id='3' type='Circle' />.</div>
          </div>
          <div style='flex: 1'>
            <div><u style='color: #00a8ec'>&emsp;big&emsp;</u></div>
            <div><input id='0' /></div>
            <div><input id='1' /></div>
            <div><input id='2' /></div>
            <div><input id='3' /></div>
          </div>
        </div>
      `,
    },
  },

}

export default json;